<template>
  <supplier-po-wo :poStillOpen="false"/>
</template>

<script>
export default {
  name: 'SupplierPoWoOpen',
  components: {
    'supplier-po-wo': () => import(/* webpackChunkName: 'RFQSupplierPoWo' */ '@/components/Shared/RFQSupplierPoWo')
  }
}
</script>
